import i18n from './../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";
import _ from 'lodash';

export default class TemporaryItemsSearch extends BaseModel {
  customer_uuid = null;
  specialist_uuid = null;
  created_at = null;
  progress = null;
  potential = null;

  rules = {};

  attributeLabels = {
    customer_uuid: i18n.t('Customer'),
    specialist_uuid: i18n.t('Specialist'),
    created_at: i18n.t('Date'),
    progress: i18n.t('Progress'),
    potential: i18n.t('Potential'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    delete data.specialist;

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        if (attr === 'customer_uuid') {
          value = _.capitalize(this.customer.display_name);
        }

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }
    return returnData;
  }
}

defineTranslatableProperties(TemporaryItemsSearch);
